module.exports = __webpack_public_path__ + "static/media/video.4387235d.svg";